import { Component, inject, Input, OnInit } from "@angular/core";
import { VisualizationOptionsType } from "@arch/_shared/types/options-visualization";
import {
    CompanyEntity,
    PointEntity,
    SerieEntity,
    VisualizationEntity
} from "@arch/domain/entity";
import { HighchartsRenderComponent } from "../../highcharts-render/highcharts-render.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { ChartHistoricComponent } from "../../chart-historic/chart-historic.component";
import _ from "lodash";
import { FormatNumbers } from "@arch/_shared/utils/format-number.utils";
import { DeviceService } from "@app/shared/services/device.service";

@Component({
    selector: "app-special-employee-cost",
    imports: [FlexLayoutModule, SharedDsnModule, ChartHistoricComponent],
    templateUrl: "./special-employee-cost.component.html",
    styleUrl: "./special-employee-cost.component.scss"
})
export class SpecialEmployeeCostComponent implements OnInit {
    @Input({ required: true }) visualization: VisualizationEntity;
    @Input({ required: true }) options: VisualizationOptionsType;
    @Input({ required: true }) series: SerieEntity[];
    @Input({ required: true }) points: PointEntity[];
    @Input({ required: true }) company: CompanyEntity;

    private readonly deviceService = inject(DeviceService);
    public readonly isMobile = this.deviceService.getIsMobile();

    public employeeSalary: number = 1000;
    public result: string = "0";
    public resultSalary: string = "";

    ngOnInit(): void {
        this.visualization.setChartHistoricCategoryVisualization("column");
        this.getResultCost();
        this.getResultSalary(this.employeeSalary);
    }

    onValueChange(value: any) {
        if (value == this.resultSalary) return;
        this.getResultSalary(value);
    }

    public getCost(): number {
        if (!_.get(this.points, "length") || !_.get(this.series, "length"))
            return 0;
        const points = this.points.filter(
            (p) => p.props.s == _.get(this.series, "[0].props._id")
        );
        const point = points.find((p) => +p.t == +this.options.endDate);
        return _.get(point, "props.m.v") || 0;
    }

    public getResultSalary(value: number) {
        const resultCost = this.getCost();
        this.resultSalary = (value * resultCost).toLocaleString("pt-BR");
    }

    public getResultCost() {
        const resultCost = this.getCost();
        this.result = (this.employeeSalary * resultCost).toLocaleString(
            "pt-BR"
        );
    }
}

export interface ISpecialEmployeeCostComponent {
    series: SerieEntity[];
    points: PointEntity[];
    visualization: VisualizationEntity;
    options: VisualizationOptionsType;
    company?: CompanyEntity;
}
